module.exports = __webpack_public_path__ + "img/9_115.aa7e3bd5.png";